import styled from "styled-components";
import colors from "../../../colors";

export const AdminSectionTitleContainer = styled.div`
  width: 100%;
  height: 8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid ${colors.primary};
  background-color: ${colors.background};
`;
